import { render, staticRenderFns } from "./Colours.vue?vue&type=template&id=6f5292ae&scoped=true&"
import script from "./Colours.vue?vue&type=script&lang=js&"
export * from "./Colours.vue?vue&type=script&lang=js&"
import style0 from "./Colours.vue?vue&type=style&index=0&id=6f5292ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5292ae",
  null
  
)

export default component.exports